import { Survey } from "@tree-company/tree-query";
import { CollectClient } from "@tree-company/collect-js-client";
import { PROJECTS } from "./data/data";
import IntroPage from "./components/intro_page";
import Swipe from "./components/swipe";
import SwipePage from "./components/swipe_page";
import Results from "./components/results";
import ResultsPage from "./components/results_page";
import translate from "./locales";
import defaultNL from "@tree-company/tree-query/locales/nl";

const SURVEY_VERSION = "v1";
// Index of the next card to show in the swipe deck. Stored in the treesponse
// answers so a returning voter can resume mid-deck (and Collector returns it
// alongside the votes).
export const PROGRESS_KEY = "vote_progress";
export const QUEUE_KEY = "queue";
export const VIEWED = 1;
export const VOTE_YES = 2;
export const VOTE_NO = 3;
export const projAnswerKey = (id) => `proj_${id}`;

export let responseCollectorURL = import.meta.env.VITE_COLLECTOR_URL;
if (responseCollectorURL === undefined && import.meta.env.DEV) {
  responseCollectorURL = "http://localhost:3000";
}

const COLLECT_API_SETTINGS = responseCollectorURL
  ? {
      url: responseCollectorURL,
      projectKey: import.meta.env.VITE_COLLECTOR_KEY,
    }
  : null;

const client = new CollectClient(COLLECT_API_SETTINGS);

export const store = client.initTreesponse({
  language: "nl",
  surveyVersion: SURVEY_VERSION,
});

export function buildSurveySettings(projects = PROJECTS) {
  return {
    key: "burgerbegroting-2026",
    translations: defaultNL,
    pages: [
      {
        order: 1,
        component: IntroPage,
        awaitSave: true,
        key: "rrn",
        title: { nl: translate("rrn.page_title") },
        sections: [
          {
            order: 1,
            title: { nl: translate("rrn.input.label") },
            required: true,
            key: "validationCode",
            type: "rrn",
            placeholder: { nl: translate("rrn.input.placeholder") },
            maxLength: 15,
          },
        ],
      },
      {
        order: 2,
        key: "vote",
        title: { nl: translate("swipe.intro.title") },
        component: SwipePage,
        sections: [
          {
            order: 1,
            type: "checkboxes",
            key: "projects",
            title: { nl: translate("swipe.intro.title") },
            component: Swipe,
            options: projects.map((project) => ({
              value: project.id,
              label: { nl: project.title },
              img: { url: project.image, alt: project.title },
            })),
          },
        ],
      },
      {
        order: 3,
        key: "results",
        component: ResultsPage,
        sections: [
          {
            order: 1,
            type: "content",
            key: "results_content",
            component: Results,
          },
        ],
      },
    ],
  };
}

export const survey = new Survey(buildSurveySettings(), store);

/**
 * Reconcile a stored queue with the current project catalog: drop ids that no
 * longer exist, and append catalog ids the queue doesn't know about (projects
 * added after the queue was generated) at the end.
 *
 * @param {string[]|null|undefined} savedQueue
 * @param {string[]} projectIds
 * @returns {string[]}
 */
export function reconcileQueue(savedQueue, projectIds) {
  const valid = (savedQueue ?? []).filter((id) => projectIds.includes(id));
  const missing = projectIds.filter((id) => !valid.includes(id));
  return [...valid, ...missing];
}
